export default "https://storage.googleapis.com/prepweb-prod/dist/0278f5e64c8cbcc4ee46e70635821e8d.svg";